
import CMSUserRepository from '@/repositories/CMSUserRepository';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ClientTypeRepository from '@/repositories/ClientTypeRepository';
import CMSUser from '@/models/CMSUser';

@Component({
    name: 'AdditionalInformation',
})
export default class AdditionalInformation extends Vue {
    @Prop({ required: true }) private value!: any;

    private get salesmen() {
        return CMSUserRepository.getAllSalesmen();
    }

    private get clientTypes() {
        return ClientTypeRepository.getAll();
    }

    private mounted() {
        CMSUser.getAll();
    }

    @Watch('value', {
        immediate: true,
        deep: true,
    })
    private onValueChange() {
        this.$emit('input', this.value);
    }
}
